module.exports = __webpack_public_path__ + "static/media/Maestro.03b476d0.svg";